import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["confirmationInput", "confirmButton"]

  connect() {
    this.confirmButton = document.getElementById("confirmDeleteButton")
    this.confirmationInput = document.getElementById("deleteCompanyConfirmationInput")
    this.companyName = this.element.dataset.deleteCompanyName // Get the company name from data attribute
  }

  validate() {
    if (this.confirmationInput.value.trim() === this.companyName) {
      this.confirmButton.disabled = false
    } else {
      this.confirmButton.disabled = true
    }
  }

  confirmDelete() {
    const form = document.getElementById("deleteCompanyForm")
    form.submit()
  }
}
